import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { logout } from 'features/Auth/actions';
import { ROUTES } from 'navigation/constants';
import { shouldSeeAllLessons } from 'features/Auth/selectors';

export const useProfileService = () => {
  const { pathname: currentRouteName } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isSubscriber = useSelector(shouldSeeAllLessons);

  const handleLogout = useCallback(() => {
    navigate(ROUTES.HOME.path);
    dispatch(logout());
  }, [dispatch]);

  return { handleLogout, currentRouteName, isSubscriber };
};
